module.exports = __webpack_public_path__ + "img/symbol_5.996fa699.png";